import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {MAJOR, MINOR, HARMONIC_MINOR} from 'effects/midi/chords/scales.js';
import Dropdown from 'react-dropdown';

const OPTIONS = [
    {label: "Major", value: MAJOR},
    {label: "Minor", value: MINOR},
    {label: "Harmonic Minor", value: HARMONIC_MINOR},
    ];

const ScaleChooser = ({effect, scale}) => { 
    const onChange = useCallback((e) => {
        effect.scale = e.value;
    }, [effect]);

    return (
        <div className="scale-chooser">
          <div className="scale-label">Scale: </div>
          <Dropdown
            className='osc-type-dropdown float-left'
            controlClassName='osc-type-control-dropdown'
            arrowClassName='osc-type-arrow-dropdown'
            options={OPTIONS}
            onChange={onChange}
            value={OPTIONS.find(x => x.value === scale)}
            placeholder="Rate" />
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      scale: props.effect.scale
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScaleChooser);
